import { Component, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
 selector: 'iho-slider-bg-text-skeleton',
 standalone: true,
 imports: [CommonModule],
 templateUrl: './slider-bg-text-skeleton.component.html',
 styleUrls: ['./slider-bg-text-skeleton.component.scss'],
})
export class SliderBgTextSkeletonComponent {
      platformId = inject(PLATFORM_ID)
 navigatorVal: any = isPlatformBrowser(this.platformId)
  ? /Android|iPhone/.test(window.navigator.userAgent)
  : undefined;
}
